import React, { useState } from 'react';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useSelector } from 'react-redux';
import { userSelector } from '../features/user/userSlice';

// import Session from './Session';
import ThemeSelector from './ThemeSelector';
import LanguageSelector from './LanguageSelector';

import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Link from '@mui/material/Link';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Badge from '@mui/material/Badge';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';

import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// import PasswordIcon from '@mui/icons-material/Password';
import MailIcon from '@mui/icons-material/Mail';
import NotificationsIcon from '@mui/icons-material/Notifications';
// import MoreIcon from '@mui/icons-material/MoreVert';

import LeBelierLogo from '../img/lebelier_logo.png';

function Navigation() {
  const { t } = useTranslation(['user']);

  const navigate = useNavigate();

  const { user } = useSelector(userSelector);

  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  // const handleChangePassword = () => {
  //   handleMenuClose();
  //   navigate('/users/changepassword');
  // };

  const handleLogout = () => {
    handleMenuClose();
    navigate('/logout');
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  // const handleMobileMenuOpen = (event) => {
  //   setMobileMoreAnchorEl(event.currentTarget);
  // };

  const menuId = 'primary-menu';
  const renderMenu = (
    <Menu
      id={menuId}
      anchorEl={anchorEl}
      // anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      keepMounted
      // transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {/* <MenuItem sx={{ py: 2 }} onClick={handleChangePassword}>
        <Box sx={{ pt: 1, width: '3em' }}>
          <PasswordIcon />
        </Box>
        {t('change_password')}
      </MenuItem> */}
      <MenuItem sx={{ py: 2 }} onClick={handleLogout}>
        <Box sx={{ pt: 1, width: '3em' }}>
          <LogoutIcon />
        </Box>
        {t('logout')}
      </MenuItem>
    </Menu>
  );

  const mobileMenuId = 'primary-menu-mobile';
  const renderMobileMenu = (
    <Menu
      id={mobileMenuId}
      anchorEl={mobileMoreAnchorEl}
      // anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      keepMounted
      // transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      {/* <MenuItem sx={{ py: 2 }} onClick={handleChangePassword}>
        <Box sx={{ pt: 1, width: '3em' }}>
          <PasswordIcon />
        </Box>
        {t('change_password')}
      </MenuItem> */}
      <MenuItem sx={{ py: 2 }} onClick={handleLogout}>
        <Box sx={{ pt: 1, width: '3em' }}>
          <LogoutIcon />
        </Box>
        {t('logout')}
      </MenuItem>
      <MenuItem>
        <IconButton aria-label="show 4 new mails" color="inherit">
          <Badge badgeContent={4} color="secondary">
            <MailIcon />
          </Badge>
        </IconButton>
        <p>Messages</p>
      </MenuItem>
      <MenuItem>
        <IconButton aria-label="show 11 new notifications" color="inherit">
          <Badge badgeContent={11} color="secondary">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircleIcon />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" elevation={0} enableColorOnDark>
        <Toolbar>
          <Link color="inherit" underline="none" component={RouterLink} to="/">
            <img
              src={LeBelierLogo}
              style={{ marginRight: '16px', maxWidth: '35px' }}
              alt="logo"
            />
          </Link>
          <Link color="inherit" underline="none" component={RouterLink} to="/">
            <Typography
              sx={{
                display: {
                  display: 'none',
                  sm: 'block',
                },
              }}
              variant="h6"
              noWrap
            >
              {t('common:title')}
            </Typography>
            {user?.plant?.plantName}
          </Link>
          <Box sx={{ flexGrow: 1 }} />
          <Box
            sx={{
              display: {
                display: 'none',
                md: 'flex',
              },
            }}
          >
            {/* <Session /> */}
            <ThemeSelector />
            <LanguageSelector />
            {user && (
              <Button
                color="inherit"
                sx={{ px: 2, ml: 1 }}
                aria-label="user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                startIcon={<AccountCircleIcon />}
              >
                {user.name ? user.name : user.username}
              </Button>
            )}
            {!user ? (
              <Button
                color="inherit"
                aria-label="login"
                sx={{ px: 2, ml: 1 }}
                startIcon={<LoginIcon />}
                component={RouterLink}
                to="/login"
              >
                {t('login')}
              </Button>
            ) : null}
          </Box>
          <Box
            sx={{
              display: {
                display: 'flex',
                md: 'none',
              },
              alignItems: 'center',
            }}
          >
            <ThemeSelector />
            <LanguageSelector isMobile={true} />
            {user && (
              <Button
                color="inherit"
                sx={{ px: 2, ml: 1 }}
                aria-label="user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                startIcon={<AccountCircleIcon />}
              >
                {user.name ? user.name : user.username}
              </Button>
            )}
            {!user ? (
              <Button
                color="inherit"
                aria-label="login"
                sx={{ px: 2, ml: 1 }}
                startIcon={<LoginIcon />}
                component={RouterLink}
                to="/login"
              >
                {t('login')}
              </Button>
            ) : null}
            {/* <IconButton
              aria-label='show more'
              aria-controls={mobileMenuId}
              aria-haspopup='true'
              onClick={handleMobileMenuOpen}
              color='inherit'
            >
              <MoreIcon />
            </IconButton> */}
          </Box>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </Box>
  );
}

export default Navigation;
